export const titleCase = value => value && value[0].toUpperCase() + value.substring(1, value.length);
frontendApp.filter('titlecase', [() => titleCase]);
